import * as React from 'react'
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax
import { useSelector, useDispatch } from 'react-redux'
import { setMarker } from '../../redux/slices/Map/map'
import { Box, Stack } from '@mui/material'
//Icons
import Botton from '../BottonCustom'
import AdjustIcon from '@mui/icons-material/Adjust'

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN
const COLOR_POPUP = 'var(--color-green)'
const COLOR_WHITE = '#fffafa'

const MIN_WIDTH_CONTENT = '110px'

const styleDefault = () => ({
  color: COLOR_POPUP,
  border: `2px solid ${COLOR_POPUP}`,
  borderRadius: '16px',
  width: '100%',
  fontSize: '12px',
  '&:hover': {
    border: `2px solid ${COLOR_POPUP}`,
    backgroundColor: COLOR_POPUP,
    color: COLOR_WHITE,
  },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})

const ContentMoveMarker = ({ coordinates }) => {
  const dispatch = useDispatch()
  const popupOpen = useSelector(state => state.mapState.popupOpen)

  const handleMoveTree = () => {
    dispatch(
      setMarker({
        openMarker: true,
        draggable: true,
        lnglat: coordinates,
      })
    )
  }

  React.useEffect(() => {
    if (!popupOpen) return
    dispatch(setMarker({ openMarker: true, draggable: true, lnglat: coordinates }))
    return () => dispatch(setMarker({ openMarker: false, draggable: false, lnglat: [] }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinates])

  if (!popupOpen) return null

  return (
    <Box sx={{ minWidth: MIN_WIDTH_CONTENT, boxShadow: 'none' }}>
      <Stack
        spacing={1}
        sx={{
          alignItems: 'center',
          py: 0,
          px: 0,
        }}>
        <Box sx={{ width: 120 }}>
          <Botton
            text=""
            onClick={handleMoveTree}
            startIcon={<AdjustIcon />}
            styleButton={styleDefault()}
            styleText={{
              '&:before': {
                content: '"UBICACIÓN ACTUAL"',
              },
              '&:hover:before': {
                content: '"REUBICAR ÁRBOL"',
              },
            }}
          />
        </Box>
      </Stack>
    </Box>
  )
}

export default ContentMoveMarker
